import classCheckPrivateStaticAccess from "./_class_check_private_static_access.mjs"

export default function _classStaticPrivateMethodGet(receiver, classConstructor, method) {
  classCheckPrivateStaticAccess(receiver, classConstructor); return method;
}
